import { DateISO } from '@agro-club/agroclub-shared'
import { Company } from 'modules/domain/company/types'
import { Address, Product } from 'modules/domain/types'
import { User } from 'modules/domain/user/types'
import { SamplesProgressStatuses, SampleStatus } from 'views/pages/Samples/types'

export enum USBidContractType {
  basis = 'basis',
  cash_priced = 'cash_priced',
}

export enum BidKind {
  potential = 'potential',
  regular = 'regular',
  futures = 'futures',
  basis = 'basis',
  cash_priced = 'cash_priced',
}

export type BidParameter = {
  parameter: {
    id?: number
    name?: string
  }
  condition_label?: string
  parameter_value?: number
  description: string
  id?: string
  parameters_description?: string
  parameter_value_from?: number
  parameter_value_to?: number
}

export type BidPricePeriod = {
  id?: string
  start_date: DateISO | null
  end_date: DateISO | null
  status: BidStatus
  price: number | null
  created?: string
  modified?: string
  quantity?: number
}

export enum BidStatus {
  published = 'published',
  archived = 'archived',
  potential = 'potential',
  completed = 'completed',
}

export enum BidTypes {
  sale = 'sale',
  purchase = 'purchase',
}

export enum BidPrice {
  CPT = 'CPT',
  EXW = 'EXW',
}

export enum USDeliveryOptions {
  Delivered = 'Delivered',
  FOB_Farm = 'FOB Farm',
}

type ShortUser = {
  id: number
  full_name: string
  is_active: boolean
  phone: string
}

export type Bid = {
  id: string
  bid_type: BidTypes
  start_date: string | null
  end_date: string | null
  product: Product
  parameters: BidParameter[]
  parameters_description: string
  status: BidStatus
  has_samples: boolean
  last_comment?: {
    text: string
    author: string
    created: string
  } | null
  quantity: number
  remaining_quantity: number
  created: string
  created_by: ShortUser | null
  responsible: ShortUser | null
  modified: string
  price: number
  price_type: BidPrice
  address: Address
  distance: number
  company: Company
  owner: User
  owner_is_significant?: boolean
  owner_is_verified_by_coordinator?: boolean
  owner_is_verified_by_security?: boolean
  owner_is_verified_by_kyc?: boolean
  owner_is_verified?: boolean
  has_files?: boolean
  bid_tag?: BidTags
  owner_delivery_address?: Address
  source: string
  season?: Season
  use_season_in_matching?: boolean
  is_for_warehouse?: boolean
  // Probably sample field exist not every api TODO check it
  sample: UserBidSample | null
}

type UserBidSample = {
  id: number
  title: string
  created: string
  expire_at: string | undefined
  modified: string
  published_at: string
  status: SampleStatus
  sample_request_status: SamplesProgressStatuses
}

export type USBid = Bid & {
  symbol: string
  basis: number
  futures_price: number
  price_exw_basis: number
  price_exw: number
  sale_price_delivered_basis: number
  sale_price_delivered: number
  basis_expiration: DateISO
  expires_at: DateISO
  owner_delivery_distance: number
  contract_type: USBidContractType
  hedge_ticket: string | null
  is_firm: boolean
}

export type BidParameterDTO = {
  parameter?: number
  parameter_value_from?: number
  parameter_value_to?: number
}

export enum UIBidTypes {
  purchase = 'purchase',
  sale = 'sale',
  potential = 'potential',
}

export enum BidTags {
  EXPORT = 'export',
  DEFERRED = 'deferred',
  TAXED = 'taxed',
}

export interface Season {
  id: string
  name: string
  product: string
  startDate: string
  end_date: string
}

export type BidAddFields = {
  bid_type: BidTypes
  company?: string
  owner?: string
  product?: string
  price?: number
  price_type?: BidPrice
  quantity?: number
  address?: string
  mainParameter: BidParameterDTO
  parameters: BidParameterDTO[]
  bid_tag?: BidTags
  owner_delivery_address?: number | undefined
  season?: string
  use_season_in_matching?: boolean
}

export type BidEditableFields = {
  price?: number
  quantity?: number
  mainParameter: BidParameterDTO
  parameters: BidParameterDTO[]
  season?: string
  use_season_in_matching?: boolean
}

export type PotentialBidEditableFields = {
  price?: number
  quantity?: number
  parameters: BidParameterDTO[]
}

export enum BidSources {
  INTERNAL = 'internal',
  BARCHART = 'barchart',
}

export type BidContractTotalsItem = {
  slug: string
  title: string
  quantity: number
  remaining_quantity: number
  rematching_quantity: number
}

export enum UIContractTypes {
  purchase = 'purchase',
  sale = 'sale',
}

export enum ContractPaymentType {
  at_gate = 'at_gate',
  before_loading = 'before_loading',
  fix_date = 'fix_date',
  periodic_parametrized = 'periodic_parametrized',
}

export enum PositionStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum PositionType {
  LONG = 'long',
  SHORT = 'short',
}

export type Position = {
  bid: USBid
  id: string
  position_status: PositionStatus
  position_type: PositionType
  quantity: string
  remaining_quantity: string
}
